import React, { Fragment } from 'react';
import GenericButton from '../../common/GenericButton';

const FunctionBoxButtonGroup = ({
  moveAppendToCodingBox,
  moveToColumns,
  moveToRows,
  addToDefinitionModal,
}) => {
  return (
    <Fragment>
      <div className="text-right">
        <GenericButton
          name="Move to Coding Box"
          btnStyle="button small button-100pt"
          onBtnClick={() => moveAppendToCodingBox(true)}
        />
      </div>
      <div className="text-right">
        <GenericButton
          name="Append to Coding Box"
          btnStyle="button small button-100pt"
          onBtnClick={() => moveAppendToCodingBox(false)}
        />
      </div>
      <div className="text-right">
        <GenericButton
          name="Move to Columns"
          btnStyle="button small button-100pt"
          onBtnClick={moveToColumns}
        />
      </div>
      <div className="text-right">
        <GenericButton
          name="Move to Rows"
          btnStyle="button small button-100pt"
          onBtnClick={moveToRows}
        />
      </div>
      <div className="text-right">
        <GenericButton
          name="Save to Definitions"
          btnStyle="button small button-100pt"
          onBtnClick={addToDefinitionModal}
        />
      </div>
    </Fragment>
  )
}

export default FunctionBoxButtonGroup;